import { ISection } from '../../../interfaces/scheduler_interfaces';
import { ICommand } from 'core-ts-types';
import { RegistrationAlertsServant } from '../../course_scheduler/servants/registration_alerts_servant';
import { UpdateSectionSelectedFlagCommand } from '../../unscheduled_sections/commands/update_section_selected_flag_command';

export class UnscheduleSectionFacade {
  constructor(
    private $stateParams: ng.ui.IStateParamsService,
    private updateSectionSelectedFlagCommand: UpdateSectionSelectedFlagCommand,
    private $state: ng.ui.IStateService,
    private unscheduleSectionCommand: ICommand,
    private getCourseSchedulerCommand: ICommand,
    private ngRegistrationAlertsServant: RegistrationAlertsServant
  ) {}

  unschedule(section: ISection) {
    this.unscheduleSectionCommand(this.$stateParams.termId, section.id)
      .then(() => this.getCourseSchedulerCommand(this.$state.params.termId))
      .then(() => this.updateSectionSelectedFlagCommand(section.id))
      .then(() => {
        this.resetStateandUpdateSectionAvailabilities();
        this.ngRegistrationAlertsServant.showUnscheduleSectionSuccessAlert(section.id);
      })
      .catch(() => this.ngRegistrationAlertsServant.showUnScheduleFailAlert(section.id));
  }

  private resetStateandUpdateSectionAvailabilities() {
    if (this.$state.is('my.schedule.registration.courseSections')) {
      this.$state.go('^');
    }
  }
}
angular.module('capability-ng-scheduler').service('ngUnscheduleSectionFacade', UnscheduleSectionFacade);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/registration/facades/unschedule_section_facade.ts